export const OLD_URLS = {
  investigated: 'oldUrl-investigated',
  pm: 'oldUrl-PM',
  user_and_prosecutor: 'oldUrl',
};
